import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgVelocity = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-velocity';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.36 3.279c-2.547.185-4.828 1.393-6.376 3.375-.939 1.203-1.556 2.77-1.703 4.326-.024.263-.041 1.822-.041 3.88v3.44l1.23 1.23 1.23 1.23h12.6l1.23-1.23 1.23-1.23v-3.44c0-3.533-.015-3.956-.164-4.734-.228-1.185-.834-2.517-1.58-3.472a8.8 8.8 0 0 0-5.776-3.309 10.4 10.4 0 0 0-1.88-.066M11.24 5.9V7h1.52V5.9c0-.853.011-1.1.05-1.1.105.001.584.085.93.163 1.127.254 2.35.888 3.199 1.657l.2.181-.832.832-.832.832.52.538.519.537.796-.792.796-.793.142.233c.326.531.609 1.184.759 1.752.17.648.196.898.22 2.11l.022 1.19h-5.428l1.109-1.11 1.11-1.111-.53-.529-.531-.53-1.639 1.64-1.64 1.64H4.751l.022-1.19c.024-1.212.05-1.462.22-2.11.15-.568.433-1.221.759-1.752l.142-.233.783.78.783.78.54-.516.54-.515-.84-.843-.84-.844.2-.179a8 8 0 0 1 1.78-1.167c.669-.309 1.751-.612 2.31-.646l.09-.005zm8 10.33v1.471l-.77.769-.771.77H6.301l-.771-.77-.77-.769V14.76h14.48z"
    })
  }));
});
export default SvgVelocity;